export default __webpack_public_path__ + "static/media/ena.cc249006.png";